import React  from "react";
import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import { getOrderStatus,updateOrderReqStatus,getMenus} from "../../crud/auth.crud";

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class EditOrderReqStatus extends React.Component {
  state = {
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    jobRequest:null,
   mStatus:[],
   permission:[],

   }

constructor(props)
{
  super(props);
 
    this.state = {
      menu: false,
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      mStatus:[],
      order:null,
      permission:[],
    };
  
}
  
  
 
  async componentDidMount()
  {
    
   

  if(this.props.order!=null)
  {
    this.setState({order:this.props.order});
  }
 
     getOrderStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });

     getMenus().then(response => response.data)
         .then((data) => {
           
           if(data[0] != null && data[0].permissions !=null)
                     {
                      
                       console.log(data[0].permissions);
                       let perms="";
                       data[0].permissions.map((per) =>(
                         perms = perms + "," + per
                         ))
                       console.log(perms);
                        this.setState({ permission: perms })
     
                     }
          })
   
  }





  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          {this.state.order != null &&

          <Formik
                  initialValues={{
                 
                    status: this.state.order.orderStatusKey,
                 
                    
                  }}
                  validate={values => {
                    const errors = {};

                    if (!values.status) {
                      errors.status = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                   this.setState({loading:true});
                   let order = {
                     
                      orderStatusKey: values.status,
                    

                   };
                    updateOrderReqStatus(this.state.order.id,values.status)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({status:true,
                        statusMessage:'Order Status has been updated successfully',
                        alertType:'alert-success',loading:false});
                        window.scrollTo(0,0);
                        let order = this.state.order;
                        order.orderStatusKey = values.status;
                        this.props.onUpdate(order);
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
     
          <div className="kt-section">
            <div className="kt-section__content">
            

         
              <div className="row">
                <TextField
                              labelId="status-label"
                              id="status"
                              margin="normal"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                              className="kt-width-full"
                              label="Select Status"
                              style={{'width':'100%'}}
                            select>
                              
                             
                              {this.state.mStatus.map((status) =>(
                               
                               (this.state.permission.includes("ALLOWEDORDERSTATUS:"+status.orderStatusId) || status.orderStatusId === values.status)&& <MenuItem key={status.orderStatusId} value={status.orderStatusId}>{status.statusDescription}</MenuItem>
                                 
                                 
                                
                              ))}
                            </TextField>
              </div>
            
    

              
        </div>
        </div>
       
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
              

        </form>
            )}
            </Formik>
          
      }

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditOrderReqStatus));

